import { type Properties } from "signlets";

export type TextInputProps = {
  value: string;
  onChangeValue: (_: string) => void;
};

export const TextInput = ({
  value,
  onChangeValue,
}: Properties<TextInputProps>) => {
  const onInput = ({
    currentTarget,
  }: Event & { currentTarget: HTMLInputElement }) => {
    const { value } = currentTarget;
    onChangeValue(value);
  };

  return <input type="text" value={value} onInput={onInput} />;
};
